import { log } from "../../shared/services/debug-logger";
import { api, apiUrl } from "../../shared/services/service";
import { openPendingForm } from "../../tech-form/services/tech-forms.service";
import { NotificationM } from "../models/notifications.models";
import { NavigateFunction } from "react-router";

const normalizeNotification = (notification: NotificationM): NotificationM => {
  if (notification.TYPE === "HULL_CLEANING" || notification.TYPE === "HULL_CLEANING_REQUESTED") {
    return {
      ...notification,
      REQUEST_ID: notification.REQUEST_ID ?? notification.TC_CODE,
    };
  }

  return notification;
};

// User is retrieved via token to prevent illegal access
export async function getUserNotifications(): Promise<NotificationM[]> {
  const result = await api.get(`${apiUrl}/notifications`);
  log("REPO - getUserNotifications - response", { count: result.data?.length ?? 0, status: result.status });

  return ((result.data || []) as NotificationM[]).map(normalizeNotification);
}

export async function postNotificationRead(id: number) {
  try {
    await api.post(`${apiUrl}/notifications/${id}/read`);
  } catch (error) {}
}

export async function postAllNotificationsRead(notifications: NotificationM[]) {
  const unseenNotifs = notifications.filter((notification) => notification.IS_READ !== true);
  log("SERV - postAllNotificationsRead", { count: unseenNotifs.length });
  unseenNotifs.forEach((notif) => {
    notif.IS_READ = true;
    postNotificationRead(notif.ID);
  });
}

export const openNotificationUrl = (notification: NotificationM, navigate: NavigateFunction) => {
  log("SERV - openNotificationUrl", { type: notification.TYPE, notificationId: notification.ID });
  postNotificationRead(notification.ID);

  const hullCleaningRequestId = notification.REQUEST_ID ?? notification.TC_CODE;
  const vesselDetailsParams = new URLSearchParams({ tab: "hull-cleaning" });
  if (hullCleaningRequestId) {
    vesselDetailsParams.set("requestId", hullCleaningRequestId);
  }

  switch (notification.TYPE) {
    case "VESSEL_ASSESMENT":
      navigate(`/voyage/details/${notification.TC_CODE}/${notification.VOYAGE_NO}/pnl`);
      break;
    case "MISSING_DOCUMENTS":
      navigate(`/missing-documents?vessel=${notification.VESSEL_NAME}`);
      break;
    case "TECH_FORM":
      openPendingForm(
        {
          IMO_NUMBER: notification.IMO_NUMBER,
          VESSEL_NAME: notification.VESSEL_NAME,
          VESSEL_CODE: notification.VESSEL_CODE,
          TYPE: "TECH",
        },
        navigate,
      );
      break;
    case "TECH_FORM_REMINDER":
      openPendingForm(
        {
          IMO_NUMBER: notification.IMO_NUMBER,
          VESSEL_NAME: notification.VESSEL_NAME,
          VESSEL_CODE: notification.VESSEL_CODE,
          TYPE: "TECH",
        },
        navigate,
      );
      break;
    case "BALTIC_FORM":
      openPendingForm(
        {
          IMO_NUMBER: notification.IMO_NUMBER,
          VESSEL_NAME: notification.VESSEL_NAME,
          VESSEL_CODE: notification.VESSEL_CODE,
          TYPE: "BALTIC",
        },
        navigate,
      );
      break;
    case "BALTIC_FORM_REMINDER":
      openPendingForm(
        {
          IMO_NUMBER: notification.IMO_NUMBER,
          VESSEL_NAME: notification.VESSEL_NAME,
          VESSEL_CODE: notification.VESSEL_CODE,
          TYPE: "BALTIC",
        },
        navigate,
      );
      break;
    case "HULL_CLEANING":
    case "HULL_CLEANING_REQUESTED":
    case "HULL_CLEANING_BOOKED":
    case "HULL_CLEANING_COMPLETED":
      navigate(
        hullCleaningRequestId
          ? `/vessel/details/${notification.IMO_NUMBER}/${notification.VESSEL_CODE}/${notification.VESSEL_NAME}/${hullCleaningRequestId}`
          : `/vessel/details/${notification.IMO_NUMBER}/${notification.VESSEL_CODE}/${notification.VESSEL_NAME}?${vesselDetailsParams.toString()}`,
      );
      break;
    default:
      log("SERV - openNotificationUrl - unsupported type", { type: notification.TYPE });
      break;
  }
};
